<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/reports"></ion-back-button>
    </ion-buttons>
    <ion-title> Payment Processing Report </ion-title>
  </ion-toolbar>
  <ion-toolbar>
    <ion-segment
      mode="ios"
      value="payments"
      (ionChange)="changeSegment($event)"
    >
      <ion-segment-button value="payments">
        <ion-label>Payments</ion-label>
      </ion-segment-button>
      <ion-segment-button value="payouts">
        <ion-label>Payouts</ion-label>
      </ion-segment-button>
      <!-- <ion-segment-button value="fees">
        <ion-label>Fees</ion-label>
      </ion-segment-button> -->
    </ion-segment>
  </ion-toolbar>
  <ion-toolbar *ngIf="segment === 'fees'">
    <salonmonster-date-picker
      [startDate]="startDate"
      [endDate]="endDate"
      [disabled]="isLoading"
      (rangeChanged)="rangeChanged($event)"
      [hideGroupBy]="true"
    ></salonmonster-date-picker>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ng-container *ngIf="segment === 'payments'">
    <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>
    <div id="container" class="ion-padding"></div>
  </ng-container>
  <ng-container *ngIf="segment === 'payouts'">
    <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>
    <div id="container" class="ion-padding"></div>
  </ng-container>

  <ng-container *ngIf="segment === 'fees'">
    <ion-button mode="md" (click)="loadCharges()"> Load Charges</ion-button>
    <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

    <ion-card>
      <ion-card-content>
        <h2>
          Total Charged: {{ totalCharged | salonMonsterCurrency }}
          <br />
          Total fees: {{ totalFees | salonMonsterCurrency }}
          <br />
          Total Deposited: {{ totalDeposited | salonMonsterCurrency }}
          <br />
        </h2>
      </ion-card-content>
    </ion-card>

    <div *ngIf="!isLoading">
      <p-table
        #dt
        styleClass="sticky-table"
        [columns]="cols"
        [value]="stats"
        sortMode="multiple"
        [globalFilterFields]="['date','size','brand','category', 'supplier']"
        [responsive]="true"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns">{{col.header}}</th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-stat let-columns="columns">
          <tr>
            <td>{{stat.date | salonMonsterDate: 'dddd, MMMM D, Y'}}</td>
            <td>{{stat.totalCharged | salonMonsterCurrency}}</td>
            <td>{{stat.fees | salonMonsterCurrency}}</td>
            <td>{{stat.totalDeposited | salonMonsterCurrency}}</td>
            <td>
              <ion-button fill="clear" (click)="viewReceipt(stat.saleID)">
                View receipt
              </ion-button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </ng-container>
</ion-content>
